const config = {
    API_URL: process.env.REACT_APP_API_URL,
    ENV: process.env.REACT_APP_ENV,
    APP_VERSION: process.env.REACT_APP_VERSION,
    DATA_API_URL: process.env.REACT_APP_DATA_API_URL,
};

export default config;
